import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CreateProviderButton: React.FunctionComponent = () => (
    <div className={classNames('text-right w-100')}>
        <Link to={Router.generate(routes.PROVIDER_CREATE)} className={`${'btn btn-success'}`}>
            <FontAwesomeIcon className={'mr-1'} icon={faPlus} />
            <span style={{ fontWeight: 'bold' }}>Add New Provider</span>
        </Link>
    </div>
);

export default CreateProviderButton;
